import httpClient from "@/lib/http-client"

/**
 * Public-side campaign fetch (Strapi).
 * We fetch `tamdaStores` directly so the registration dropdown has data
 * even if the embedded `post.campaign` relation didn't populate it.
 */
export const getCampaignById = async (id: number | string, locale?: string) => {
  const localeParam = locale || "vi"
  return await httpClient.get<{ data: any }>(`campaigns/${id}`, {
    locale: localeParam,
    // Keep preview to allow editors to test unpublished campaigns if needed.
    publicationState: "preview",
    populate: {
      tamdaStores: {
        fields: ["name", "address", "email", "longitude", "latitude", "googleMapCode", "phone", "guidance", "description", "locale"],
      },
    },
  })
}

